import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addMovie } from "../redux/slices/moviesSlice";

const AddMovie = () => {
  const [name, setName] = useState("");
  const [genre, setGenre] = useState([]);
  const [description, setDescription] = useState("");
  const [banner, setBanner] = useState("");
  const [movieUrl, setMovieUrl] = useState("");
  const [filePath, setFilePath] = useState("");
  const [fileSize, setFileSize] = useState("");
  const [mimeType, setMimeType] = useState("");
  const [runtime, setRuntime] = useState("");
  const [error, setError] = useState(null);

  const token =
    useSelector((state) => state.auth.token) || localStorage.getItem("token");

  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const movieData = {
      name,
      genre: genre,
      description,
      banner,
      movieUrl,
      filePath,
      fileSize,
      mimeType,
      runtime,
    };

    try {
      await dispatch(addMovie({ movieData, token }));
      console.log("Movie added successfully");
    } catch (err) {
      setError("Error adding movie");
      console.error("Error:", err);
    }
  };

  return (
    <div className="p-8 bg-gray-800 text-white">
      <h1 className="text-3xl font-semibold mb-6">Add New Movie</h1>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label>Movie Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className="p-2 mt-2 w-full border rounded-lg bg-gray-700 text-white"
            autocomplete="off"
          />
        </div>
        <div>
          <label>Genre</label>
          <input
            type="text"
            value={genre}
            onChange={(e) => setGenre(e.target.value.split(", "))}
            required
            className="p-2 mt-2 w-full border rounded-lg bg-gray-700 text-white"
            autocomplete="off"
          />
        </div>
        <div>
          <label>Runtime (minutes)</label>
          <input
            type="number"
            value={runtime}
            onChange={(e) => setRuntime(e.target.value)}
            required
            className="p-2 mt-2 w-full border rounded-lg bg-gray-700 text-white"
            autocomplete="off"
          />
        </div>
        <div>
          <label>Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
            className="p-2 mt-2 w-full border rounded-lg bg-gray-700 text-white"
            autocomplete="off"
          />
        </div>
        <div>
          <label>Banner</label>
          <input
            type="text"
            value={banner}
            onChange={(e) => setBanner(e.target.value)}
            required
            className="p-2 mt-2 w-full border rounded-lg bg-gray-700 text-white"
            autocomplete="off"
          />
        </div>
        <div>
          <label>Movie URL</label>
          <input
            type="text"
            value={movieUrl}
            onChange={(e) => setMovieUrl(e.target.value)}
            required
            className="p-2 mt-2 w-full border rounded-lg bg-gray-700 text-white"
            autocomplete="off"
          />
        </div>
        <div>
          <label>File Path</label>
          <input
            type="text"
            value={filePath}
            onChange={(e) => setFilePath(e.target.value)}
            required
            className="p-2 mt-2 w-full border rounded-lg bg-gray-700 text-white"
            autocomplete="off"
          />
        </div>
        <div>
          <label>File Size</label>
          <input
            type="number"
            value={fileSize}
            onChange={(e) => setFileSize(e.target.value)}
            required
            className="p-2 mt-2 w-full border rounded-lg bg-gray-700 text-white"
            autocomplete="off"
          />
        </div>
        <div>
          <label>MIME Type</label>
          <input
            type="text"
            value={mimeType}
            onChange={(e) => setMimeType(e.target.value)}
            required
            className="p-2 mt-2 w-full border rounded-lg bg-gray-700 text-white"
            autocomplete="off"
          />
        </div>
        <button
          type="submit"
          className="mt-4 bg-blue-500 text-white p-2 rounded-lg w-full"
        >
          Add Movie
        </button>
      </form>
    </div>
  );
};

export default AddMovie;
